<template>
  <div class="bottom" id="mobileBottom">
    <div class="text-center mb-2 font_14">Copyright © {{ year }} 上海帆扬宇亿科技有限公司 AII rights reserved</div>
    <div class="d-flex flex-column align-items-center font_14">
      <div class="mb-2">沪ICP备2024062463号-2</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {
      year: "",
    };
  },
    mounted() {
    this.year = new Date().getFullYear();
  },
  methods: {
    jump() {
      let that = this;
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?" +
          "recordcode=21021702000565",
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.bottom {
  position: absolute;
  background: #141623;
  width: 100%;
  color: #fff;
  font-size: 16px;
  padding: 18px 0;
  box-sizing: border-box;
  z-index: 999;
}
.title {
  font-size: 18px;
  margin-right: 54px;
}
</style>
